import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import ClearImageCloudFrontCache from '../../Services/Mutations/clearImageCloudFrontCache'
import { Button, Modal } from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert'
import { Auth } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import GetContentCreatorsAndPlannersList from '../../Services/Queries/GetContentCreatorsAndPlannersList'

import ListUsersInRole from '../../Services/Queries/ListUsersInRole'
import JobGeneralOptions from './JobGeneralOptions.js';
import CreateUserHashtag from '../../Services/Mutations/CreateUserHashtag'
import GetContentCategories from '../../Services/Queries/GetContentCategories'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import CreateAs from '../content/CreateAs'
import GetYousayInAppUser from '../../Services/Queries/GetYousayInAppUser'
import GetYouSayIdDetails from '../../Services/Queries/GetYouSayIdDetails'
import CreateContentService from '../../Services/Mutations/CreateContent'
import UpdateContent from '../../Services/Mutations/UpdateContent'
import JobDetails from './JobDetails'
import GetJobConfig from '../../Services/Queries/GetJobConfig'
import RegisterCompany from '../../Services/Mutations/RegisterCompany'
import MandatoryValidations from '../content/SubComponents/MandatoryValidations';
import { StickyPostValidations } from '../content/ConstantFunctions';
import { GetWordPressInfo } from '../content/ConstantFunctions';

const styles = {
	mandatoryErrorText: {
		fontSize: heightPercentageToDP('2'),
		color: 'red',
	},
}


class Job extends Component {
	toastStyle = {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}



	constructor(props) {
		super(props)
		const endDate = new Date(0)
		endDate.setUTCSeconds((15 * 86400) + Math.trunc(new Date().getTime() / 1000))
		this.state = {
			syncToWordpress: true,
			disableSyncToWordPress: false,
			wordPressPostStatus: 'draft',
			wordPressInfo: {},
			permalink: '',
			creationStatus: '',
			sendPNWithImage: true,
			render: false,
			contentLanguageOptions: [
				{
					label: 'Telugu',
					value: 'Te',
					id: 0,
				},
				{
					label: 'English',
					value: 'En',
					id: 1,
				},
			],

			genderOptions: [
				{ genderType: 'both', img: 'both_men_women', id: 1 },
				{ genderType: 'Male', img: 'only_men', id: 2 },
				{ genderType: 'Female', img: 'only_women', id: 3 },
			],
			sendPushNotification: false,
			files: [],
			file: '',
			imagePreviewUrl: [],
			selectedContentImages: [],
			title: '',
			description: '',
			contentSelectedLangVal: 'Te',
			createAs: 'user',
			selectedContributor: {},
			selectedContentPlanner: {},
			selectedTextColor: '#ffffff',
			link: '',
			linkText: '',
			invalidURL: false,
			suggestions: [],
			newTagsArr: [],
			tagsWithTypeArr: [],
			tagsArr: [],
			tagsWithGenderArr: [],
			tags: { tag: '', tagsArray: [] },
			tagValue: '',
			canEditTags: true,
			isFlipped: false,
			allowDownloads: false,
			createInBoxOffice: true,
			contentTitlePosition: null,
			backGroundTitle: '',
			copyRight: false,
			shareImage: false,
			copyRightText: '',
			archivalDate: null,
			pnTitle: '',
			allowShare: true,
			allowComments: true,
			isCopyRightAccepted: false,
			selectedGenderType: 'both',
			sendPushNotification: false,
			contentLang: 'English',
			displayQuesLangDropdown: false,
			editContent: false,
			selectedImagePath: [],
			sendPN: false,
			selectedContentType: 'Job',
			contentDetails: {},
			changeToType: 'Story',
			changeToLanguage: 'Te',
			isGeneralOptionsEdited: false,
			getDataFromChilds: false,
			enableCreateContent: false,
			// autoExpireOptions: autoExpireOptions,
			selectedAutoExpireDate: {
				value: 'None',
				days: 0,

				id: 1,
			},
			selectedAutoDeleteDate: {
				value: 'None',
				days: 0,

				id: 1,
			},
			scheduledDate: new Date(),
			// pollClosingDate: new Date(),
			publishedEndDate: endDate,

			contentMainCategory: 'news',
			sendPNWithBigText: false,
			bigTextTitle: '',
			// categories: CategoriesData,
			selectedCategory: '',
			modalVisible: false,
			previewData: null,
			selectedTargetAreas: [],
			selectedPnPriority: 'regularTopic',
			contentID: '',
			stickyPost: false,
			positionFromTop: '',
			stickyEndDateTime: new Date(new Date().setHours(new Date().getHours() + 12)),
			showSticky: 'Unlimited',
			stickyTargetImpressions: 10,
			isInAppMessage: false,
			inAppMessageDetails: {},
			selectedPeopleList: [],
			userDetails: {},
			pushRankUpTo: 30,
			pushRankTo: 1,
			missingSubContentMandatoryFields: false,
			missingMandatoryFields: false,
			updateErrorValidations: false,
			matchKey: '',
			tournamentKey: '',
			associationKey: '',
			teamsShortCodes: [],
			addTargetAreasToWP: false,
			targetAreaV2: [],
			addNewsToCategory: false,
			newsCategoryId: '',
			// categories: [],
			targetAreasList: [],
			companyDetails: {},
			locations: [],
			qualifications: [],
			skills: [],
			workType: [],
			jobCategories: [],
			salaryRange: [],
			jobSector: [],
			experienceRange: [],
			jobType: [],
			jobDetails: {},
		}
		this.contentImage = ''
		this.contentImages = []
		this.contentStatus = ''
		this.isPreviouslyCampaign = false
		this.InAppMessageChild = React.createRef()
		this.isPreviouslyStickyPost = false
		this.missingMandatoryFields = true
		this.missingSubContentMandatoryFields = true
		this.job = {}

	}
	getWordPressInfo = (wordPressInfo) => {
		const info = GetWordPressInfo(this.props.duplicateContent, wordPressInfo)
		return info
	}
	async componentDidMount() {
		const { duplicateContent } = this.props
		const userDetailsInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userDetails = await GetUserPermissions(userDetailsInput)
		// get all content creators or planners list

		const plannersList = await GetContentCreatorsAndPlannersList()

		const input = { roleName: 'ContentTeam' }
		const usersList = await ListUsersInRole(input)
		const items = usersList && usersList.items ? usersList.items : []

		//get general options data
		const data = await GetContentCategories()
		// console.log(data, "=======ContentCategories")

		// get job Type data
		const jobData = await GetJobConfig()
		console.log(jobData, "=======ContentCategoriesAndJobData")

		this.setState({
			// newsCategoryId: data.newsCategoryWPID,
			targetAreasList: data.targetAreaV2categoriesConfig ? data.targetAreaV2categoriesConfig : [],
			usersList: items,
			plannersList: plannersList && plannersList.items ? plannersList.items : [],
			userDetails: userDetails,
			locations: jobData.jobConfig.jobLocations,
			qualifications: jobData.jobConfig.jobQualifications,
			skills: jobData.jobConfig.jobSkills,
			workType: jobData.jobConfig.workType,
			jobCategories: jobData.jobConfig.jobCategory,
			salaryRange: jobData.jobConfig.salaryRange,
			experienceRange: jobData.jobConfig.experienceRange,
			jobType: jobData.jobConfig.jobType,
			jobSector: jobData.jobConfig.jobSector,

		})
		const contentSelectedLangVal = this.props.contentSelectedLangVal
		const details = this.props.contentDetails
		const contentDetails = this.stripTypenames(details)
		const editContent = this.props.editContent
		if (!editContent) {
			if (this.state.contentSelectedLangVal == 'En' || this.state.changeToLanguage == 'En') {
				this.setState({ syncToWordpress: false })
			}
		}
		if (editContent) {
			// console.log(editContent, details, contentDetails, "===================editContent details")
			const { contentMetaInfo } = contentDetails
			// await this.getFormattedData(editContent, contentMetaInfo)
			// const tagsArr = await this.getTagsArray(contentDetails)
			// const editTags = tagsArr[0].length == 4 ? false : true
			// const tags = {
			//     tag: '',
			//     tagsArray: tagsArr[0],
			// }
			if (contentMetaInfo?.contentImages?.length > 0) {
				const contentImages = []
				contentMetaInfo.contentImages.map((item) => {
					const contentimagesindex = item.indexOf('public')
					if (contentimagesindex > 0) {
						const strippedImage = item.substring(item.indexOf('public'))
						contentImages.push(strippedImage)
					}
				})
				this.contentImages =
					contentImages.length > 0 ? contentImages : contentMetaInfo.contentImages
			}
			let planner = ''
			if (contentDetails.contentPlanner) {

				const plannerIndex = plannersList.items.findIndex(
					(item) => item.PK == contentDetails.contentPlanner

				)
				if (plannerIndex != -1) {
					planner = plannersList.items[plannerIndex]
				}
			}
			//To Do var index = contentMetaInfo.link ? contentMetaInfo.link.indexOf('?') : -1
			if (contentMetaInfo) {
				console.log(contentMetaInfo, 'contentMetaInfocontentMetaInfo============')
				this.contentImage = contentMetaInfo.contentImage
					? contentMetaInfo.contentImage.substring(contentMetaInfo.contentImage.indexOf('public'))
					: ''
				let loggedInUserDetails = {}

				const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
				if (loggedInUserEmail) {
					const emailParams = loggedInUserEmail.split('@')
					const loggedInUserHandle = '@' + emailParams[0]
					const handleInput = { YouSayID: loggedInUserHandle }
					loggedInUserDetails = await GetYouSayIdDetails(handleInput)
				}
				this.contentStatus = contentDetails.SK
				this.isPreviouslyStickyPost =
					contentDetails.stickyPost != undefined && contentDetails.stickyPost != null
						? contentDetails.stickyPost
						: false
				const createdAs =
					contentDetails.createdAs == 'YouSay Editor'
						? 'YouSay Editor'
						: contentDetails.createdAs == loggedInUserDetails.name
							? 'user'
							: 'other'
				const selectedContributor = {
					name: createdAs == 'other' ? contentDetails.createdAs : '',
				}

				let wpcategoryIDs = []
				const wordpressInfoExists =
					contentDetails.wordPressInfo && Object.keys(contentDetails.wordPressInfo).length > 0
				// if (wordpressInfoExists) {
				//     wpcategoryIDs = await this.getWordpressCategoryIds(contentDetails.wordPressInfo)
				// }
				const contentType = contentDetails.contentType
				let contentTargetAreas = contentDetails.targetAreaV2
				let selectedTargetAreasArr = []
				if (contentTargetAreas) {
					contentTargetAreas.map((targetArea, index) => {
						const targetAreaIndex = this.state.targetAreasList.findIndex(
							(item) => item.heading == targetArea
						)
						if (targetAreaIndex != -1) {
							selectedTargetAreasArr.push(this.state.targetAreasList[targetAreaIndex])
						}
					})
				}
				// const selectedTargetAreasArr = contentDetails.targetAreaV2
				this.setState({

					addTargetAreasToWP: contentDetails.addedTargetAreaCategories,
					addNewsToCategory: contentDetails.addedNewsCategories,
					newsCategoryId: contentDetails.newsCategoriesArr,
					targetAreaV2: contentDetails.targetAreaV2,
					selectedTargetAreas: selectedTargetAreasArr,
					selectedContentPlanner: planner,
					syncToYousaytv: contentDetails.syncToYousaytv ? true : false,
					featuredImageId: wordpressInfoExists
						? contentDetails.wordPressInfo.wordPressMediaID
							? parseInt(contentDetails.wordPressInfo.wordPressMediaID)
							: ''
						: '',
					syncToWordpress:
						!this.props.duplicateContent && contentDetails.syncToYousaytv ? true : contentSelectedLangVal == 'En' ? false : true,
					permalink: !this.props.duplicateContent && wordpressInfoExists ? contentDetails.wordPressInfo.wordPressPermaLink : '',
					// WPTagIds: wordpressInfoExists ? contentDetails.wordPressInfo.wordPressTagIDs : [],
					// WPCatIds: wpcategoryIDs,
					wordPressPostStatus: wordpressInfoExists
						? contentDetails.wordPressInfo.wordPressPostStatus
						: 'draft',
					wordPressInfo: this.getWordPressInfo(contentDetails.wordPressInfo),
					contentSelectedLangVal: this.props.contentSelectedLangVal,
					generalOptionsExpanded: true,
					contentLanguage: contentDetails.contentLanguage,
					editContent: editContent,
					createdAs: contentDetails.createdAs,
					creatorUUID: contentDetails.creatorUUID,
					selectedContentType: contentType,
					sendPushNotification: contentDetails.sendPushNotification,
					bigTextTitle: contentDetails[`bigTextTitle_${contentSelectedLangVal}`],
					pnTitle: contentDetails[`pnTitle_${contentSelectedLangVal}`],
					selectedPnPriority: contentDetails.pnPriority ? contentDetails.pnPriority : 'low',
					pnDescription: contentDetails[`pnDescription_${contentSelectedLangVal}`],
					sendPNWithImage: contentDetails.sendPNWithImage,
					scheduledDate: await this.getScheduledDateObject(contentDetails.scheduledTime),
					scheduledTime: contentDetails.scheduledTime,
					// activeTillDate: contentDetails.activeTillDate,
					contentLang: contentDetails.contentLanguage,
					allowShare: contentDetails.allowShare,
					createInBoxOffice:
						contentDetails.createInBoxOffice,
					allowComments: contentDetails.allowComments,
					scheduleTime: contentDetails.scheduledTime,
					contentID: contentDetails.PK,
					stickyPost:
						contentDetails.stickyPost != undefined && contentDetails.stickyPost != null
							? contentDetails.stickyPost
							: false,
					showSticky:
						contentDetails.showSticky != undefined && contentDetails.showSticky != null
							? contentDetails.showSticky
							: 'Unlimited',
					positionFromTop:
						contentDetails.tempPositionFromTop != undefined &&
							contentDetails.tempPositionFromTop != null
							? contentDetails.tempPositionFromTop
							: contentDetails.positionFromTop != undefined &&
								contentDetails.positionFromTop != null
								? contentDetails.positionFromTop
								: '',
					stickyEndDateTime:
						contentDetails.stickyEndDateTime != undefined &&
							contentDetails.stickyEndDateTime != null
							? parseInt(contentDetails.stickyEndDateTime) * 1000
							: this.state.stickyEndDateTime,
					stickyTargetImpressions:
						contentDetails.stickyTargetImpressions != undefined &&
							contentDetails.stickyTargetImpressions != null
							? contentDetails.stickyTargetImpressions
							: '',


					pushRankTo:
						contentDetails.pushRankTo != undefined && contentDetails.pushRankTo != null
							? contentDetails.pushRankTo
							: this.state.pushRankTo,
					pushRankUpTo:
						contentDetails.pushRankUpTo != undefined && contentDetails.pushRankUpTo != null
							? contentDetails.pushRankUpTo
							: this.state.pushRankUpTo,
				})
			}
			// console.log(contentMetaInfo.jobDetails, 'contentMetaInfo.jobDetails======')
			this.job = contentMetaInfo.jobDetails
			console.log(this.job, '========job')
			const createContentValidation = this.checkCreateContentValidations()
			if (this.state.enableCreateContent != createContentValidation) {
				this.setState({ enableCreateContent: createContentValidation })
			}
			// if (duplicateContent) {
			//     this.resetDuplicateContentData()
			// }

		}
		else {
			this.changeContentIDValue()
		}
	}
	getScheduledDateObject = (dateValue) => {
		const utcSeconds = dateValue
		const scheduledDate = new Date(0) // The 0 there is the key, which sets the date to the epoch
		scheduledDate.setUTCSeconds(utcSeconds)
		const dateObj = new Date(scheduledDate)
		return scheduledDate
	}
	changeContentIDValue = async () => {
		let contentIDVal = ''
		contentIDVal = await uuidv4()
		this.setState({
			contentID: contentIDVal,
		})
	}
	handleCompanyDetails = (isNewCompany, companyDetails) => {
		console.log(companyDetails, 'companyDetails==== in handlecompanyDetails in job index----------------')
		// let details = companyDetails
		companyDetails['isNewCompany'] = isNewCompany
		this.setState({ companyDetails: companyDetails })
		this.updateInParent('companyDetails', companyDetails, 'Job')
	}

	jobData = (key, value) => {
		console.log(key, value, 'here is the key')
		console.log(this.job, 'in line 463 here is the details')

		if (key !== 'companyDetails') {
			this.job[key] = value
			console.log(this.job, 'job===========================')
		} else {

			this.job['companyName'] = value.companyName
			this.job['companyBio'] = value.companyBio
			this.job['companyRegisteredAddress'] = value.companyRegisteredAddress ? value.companyRegisteredAddress : value.companyAddress
			//this.job['companyAddress'] = value.companyRegisteredAddress ? value.companyRegisteredAddress : value.companyAddress
			this.job['contactMobileNumber'] = value.phoneNumber
			this.job['contactEmail'] = value.companyEmail
			this.job['companyWebsite'] = value.companyWebsite
			this.job['jobImages'] = value.companyLogo ? [{
				copyRight: false,
				copyRightText: "",
				imageValue: "",
				image: value.companyLogo,
				shareImage: false,
			}] : []
			this.job['GST'] = value.GST
			this.job['jobApplicationLink'] = value.jobApplicationLink
			this.job['contactName'] = value.contactName
			this.job['displayMobileNumberInJobPost'] = value.displayMobileNumberInJobPost

		}
		console.log(this.job, 'job==========================')
		this.setState({ job: this.job })
		if (key.includes('jobTitle') && value) {
			this.job["jobTitle"] = value
			this.setState({ pnTitle: value.substring(0, 45) })
		}
		if (key.includes('jobDescription') && value) {
			this.job['jobDescription'] = value
		}
		if (!this.state.editContent && key.includes('jobDescription') && value) {
			this.setState({ pnDescription: value, bigTextTitle: value })
		}
		if (key.includes('jobImages') && value && value[0]) {
			this.contentImage = value[0].image
			this.contentImages = value[0].image
		}
	}
	getJobData = () => {
		this.job[`activeTillDate`] = Math.trunc(this.state.publishedEndDate.getTime() / 1000)
		console.log(this.job, 'in line 492 job')
		if (this.job && this.job.jobImages && this.job.jobImages.length > 0) {
			this.job.jobImages.map((item, index) => {
				delete item.imageValue
			})
		}
		delete this.job.languages
		return this.job

	}
	checkSubContentValidations = () => {
		const { selectedContentType } = this.state

		// return true
		return this.jobValidations(this.job)
	}
	checkCreateContentValidations = () => {
		return this.checkSubContentValidations()
	}
	updateWordpressPermalink = (permalink) => {
		this.setState({ permalink })
	}
	syncToWordpress = (syncToWordpress) => {
		this.setState({ syncToWordpress }, () => {
			const createContentValidation = this.checkCreateContentValidations()
			this.setState({ enableCreateContent: createContentValidation })
		})
	}
	disableSyncToWordPress = (disableSyncToWordPress) => {
		this.setState({ disableSyncToWordPress })
	}
	updateInParent = (key, value, type, subType) => {
		const { enableCreateContent } = this.state
		console.log(enableCreateContent, 'here is the log in updateINParent')
		console.log(key, value, 'inside update in parent')
		this.jobData(key, value)


		const createContentValidation = this.checkCreateContentValidations()
		console.log(createContentValidation, 'inside update in parent component')
		if (enableCreateContent != createContentValidation) {
			this.setState({
				enableCreateContent: createContentValidation,
				updateErrorValidations: !this.state.updateErrorValidations,
			})
		} else {
			this.setState({ updateErrorValidations: !this.state.updateErrorValidations })
		}
	}
	getEditContentJobData = (props) => {
		console.log(props, 'in line 534')
		return props.contentDetails && props.contentDetails.contentMetaInfo
			? props.contentDetails.contentMetaInfo.jobDetails
			: {}
	}
	renderSubContent = (contentType) => {
		const { job } = this
		// console.log(job, 'job passing for rendersubcontent')
		const contentSelectedLangVal = this.props.contentSelectedLangVal
			? this.props.contentSelectedLangVal
			: this.state.contentSelectedLangVal

		let editcontentJobData = this.getEditContentJobData(this.props)
		editcontentJobData['jobSubLocation'] = job['jobSubLocation'] ? job['jobSubLocation'] : editcontentJobData['jobSubLocation']
		const editContent = this.props.editContent ? this.props.editContent : false
		const jobData = editContent ? editcontentJobData : job
		console.log(jobData, "===============jobData")
		console.log(this.state.companyDetails, 'companyDetails============ for jobcomp')
		switch (contentType) {
			case 'Job':
				return (
					<JobDetails
						enableCreateContent={this.props.enableCreateContent}
						editContent={this.props.editContent}
						companyDetails={this.state.companyDetails}
						// duplicateContent={this.props.duplicateContent}
						syncToWordpressValue={this.state.syncToWordpress}
						wordPressInfo={this.state.wordPressInfo}
						syncToWordpress={this.syncToWordpress}
						disableSyncToWordPress={this.disableSyncToWordPress}
						updateWordpressPermalink={this.updateWordpressPermalink}
						// setFeaturedImageId={this.setFeaturedImageId}
						jobDetails={jobData}
						updateInParent={this.updateInParent}
						contentSelectedLangVal={contentSelectedLangVal}
						contentID={this.state.contentID}
						locations={this.state.locations}
						qualifications={this.state.qualifications}
						skills={this.state.skills}
						workType={this.state.workType}
						categories={this.state.jobCategories}
						salaryRange={this.state.salaryRange}
						experienceRange={this.state.experienceRange}
						jobSector={this.state.jobSector}
						jobType={this.state.jobType}
						handleCompanyDetails={this.handleCompanyDetails}


					/>
				)
			default:
				return <div></div>
		}
	}
	renderContentMandatoryValidations = () => {
		const allMandatoryValidations = true
		//const job=
		const { selectedContentType } = this.state
		// console.log(this.job, 'this is the job')
		const data = this.jobValidations(this.job, allMandatoryValidations)
		return this.displayMandatoryValidations(data)
	}
	displayMandatoryValidations = (data) => {
		console.log(data, 'inside validations')
		const allMandatoryValidations = true
		const generalAndOtherOptionValidations = this.checkDisabled(allMandatoryValidations)
		const totalContentMissingFieldsObj = { ...generalAndOtherOptionValidations, ...data }
		const totalContentMissingFields = Object.keys(totalContentMissingFieldsObj)?.filter(
			(key) => totalContentMissingFieldsObj[key] == false
		)
		console.log(totalContentMissingFieldsObj, 'here is the total missing fields')
		return totalContentMissingFields.length ? (
			<MandatoryValidations totalContentMissingFields={totalContentMissingFields} />
		) : null
	}
	jobValidations = (job, allMandatoryValidations) => {
		const { contentSelectedLangVal } = this.state
		console.log(job, '=====here is the job')
		//title, desc, Qualification, Category, companyName, about, contact, experience, salary
		const sTitle =
			job?.[`jobTitle_${contentSelectedLangVal}`] != undefined &&
			job?.[`jobTitle_${contentSelectedLangVal}`] != ''
		// console.log(sTitle, 'here is the bool title')
		const sDescription =
			job?.[`jobDescription_${contentSelectedLangVal}`] != undefined &&
			job?.[`jobDescription_${contentSelectedLangVal}`] != ''
		const qualification = job?.jobQualification != undefined && job?.jobQualification != ''
		const category = job?.jobCategory != undefined && job?.jobCategory != ''
		const companyName = job?.['companyName'] != undefined && job?.['companyName'] != null
		console.log(companyName, 'in line 617')
		const about = job?.['companyBio'] != undefined && job?.['companyBio'] != ''

		const contactValidation = (job?.[`contactEmail`] != undefined && job?.[`contactEmail`] != '') || (job?.[`companyWebsite`] != undefined && job?.[`companyWebsite`] != '')
			|| (job?.[`contactMobileNumber`] != undefined && job?.[`contactMobileNumber`] != '')
		const experience = job?.experienceRange != undefined && job?.experienceRange != ''
		const salary = job?.salaryRange != undefined && job?.salaryRange != ''
		// console.log(sTitle, sDescription, qualification, category, companyName, about, contactValidation, experience, salary, "==========================validations")
		// const wordpressImageValidation = this.state.syncToWordpress
		//   ? this.state.featuredImageId != ''
		//   : true
		let valuesArr = []
		// if (job && job.storyCardImages && this.state.syncToWordpress) {
		//     story.storyCardImages.map((item, index) => {
		//         if (item.copyRight && item.copyRightText != '') {
		//             valuesArr.push(true)
		//         } else {
		//             valuesArr.push(false)
		//         }
		//     })
		// }

		// const isCopyRightTextAvailable = valuesArr.every((v) => v === true)


		// const sImages = !isYoutube
		//     ? story?.storyCardImages != undefined &&
		//     story?.storyCardImages?.length > 0 &&
		//     isCopyRightTextAvailable
		//     : false
		// const mediaValidation =
		//     sImages

		// const buttonErrValidation = this.contentButtonValidation(story)

		// return sTitle && sDescription && !buttonErrValidation
		if (allMandatoryValidations) {
			return {
				Title: sTitle,
				Description: sDescription,
				// [`${withSlideShowKey}mediaValidation`]:
				// 	mediaValidation == undefined ? false : mediaValidation,
				// [`${withSlideShowKey}buttonErrValidation`]: !buttonErrValidation,
				Qualification: qualification,
				Category: category,
				Experience: experience,
				Salary: salary,
				[`CompanyDetails: Name`]: companyName,
				[`CompanyDetails: About`]: about,
				[`CompanyDetails: Contact Email/Mobile Number/Website`]: contactValidation,

			}
		}
		return sTitle && sDescription && qualification && category && companyName && about && contactValidation && experience && salary
	}


	checkDisabled = (allMandatoryValidations) => {
		const { sendPushNotification, sendPNWithImage, pnTitle, bigTextTitle, tagsArr } = this.state
		const pnTextValidation = sendPNWithImage ? pnTitle != '' : bigTextTitle != ''
		const sendPnValidation = sendPushNotification ? pnTextValidation : true
		const enableContentValidation = this.state.enableCreateContent
		// const tagsAndPnAndTargetAreasValidation =
		// 	tagsArr.length > 0 && sendPnValidation && this.state.selectedTargetAreas.length > 0
		// const PnAndTargetAreasValidation =
		//     sendPnValidation && this.state.selectedTargetAreas.length > 0
		const stickyPostValidations = this.stickyPostValidations()
		// const inAppMessageValidations = this.inAppMessageValidations()
		//to extract and return missing validations fields, sending allMandatoryValidations prop

		if (allMandatoryValidations) {
			return {

				// [`GeneralOption: targetAreas`]: this.state.selectedTargetAreas.length > 0 ? true : false,
				[`GeneralOption: sendPnValidation`]: sendPnValidation,
				[`GeneralOption: stickyPostValidations`]: stickyPostValidations,
				// [`GeneralOption: inAppMessageValidations`]: inAppMessageValidations,
			}
		}
		return enableContentValidation
			&&
			stickyPostValidations
			// inAppMessageValidations &&
			// this.state.selectedCategory
			?
			false
			: true
	}
	stickyPostValidations = () => {
		const {
			stickyPost,
			stickyEndDateTime,
			showSticky,
			stickyTargetImpressions,
			positionFromTop,
			pushRankTo,
			pushRankUpTo,
		} = this.state
		const stickyPostValidation = StickyPostValidations(
			stickyPost,
			stickyEndDateTime,
			showSticky,
			stickyTargetImpressions,
			positionFromTop,
			pushRankTo,
			pushRankUpTo
		)
		return stickyPostValidation
	}
	getScheduledDate = () => {
		const { scheduledDate } = this.state
		const date = scheduledDate.getDate()
		const month = scheduledDate.getMonth() + 1
		const year = scheduledDate.getFullYear()
		const formatteddate = date + '/' + month + '/' + year
		return formatteddate
	}
	getScheduledTime = () => {
		const { scheduledDate } = this.state
		const time = Math.trunc(scheduledDate.getTime() / 1000)
		return time
	}
	handleModal = () => {
		this.setState({ modalVisible: !this.state.modalVisible })
	}
	contentInputData = async (contentType) => {
		const { contentDetails } = this.props
		const { createAs, selectedContributor, contentSelectedLangVal } = this.state

		const { editContent } = this.props
		const userInput = { handle: '@YouSayEditor' }
		let loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
		let loggedInUserDetails = {}
		if (loggedInUserEmail) {
			let emailParams = loggedInUserEmail.split('@')
			let loggedInUserHandle = '@' + emailParams[0]
			const handleInput = { YouSayID: loggedInUserHandle }
			loggedInUserDetails = await GetYouSayIdDetails(handleInput)
		}
		const data = await GetYousayInAppUser(userInput)

		const createdAs =
			createAs == 'other'
				? selectedContributor.name
				: createAs == 'user'
					? loggedInUserDetails && loggedInUserDetails.name ? loggedInUserDetails.name : data.name
					: data.name
		const creatorID =
			createAs == 'other'
				? selectedContributor.PK
				: createAs == 'user'
					? loggedInUserDetails && loggedInUserDetails.PK ? loggedInUserDetails.PK : data.UUID
					: data.UUID
		// if (this.props.editContent) {
		//     await this.DeleteTypeAndFormatImages(contentType)
		// }
		const contentLangs =
			editContent && contentDetails.contentLanguages ? contentDetails.contentLanguages : []
		contentLangs.push(contentSelectedLangVal)
		const updatedContentLanguages = _.uniqBy(contentLangs)
		const type = this.state.selectedContentType
		let targetAreaV2 = []
		this.state.selectedTargetAreas.map((item, index) => {
			targetAreaV2.push(item.heading)
		})
		const input = {
			contentPlanner: this.state.selectedContentPlanner.PK,
			createdAs: createdAs,
			creatorHandle: '@YouSayEditor',
			creatorName: createdAs,
			contentType: type,
			creatorUUID: creatorID,
			originalCreator:
				this.state.userDetails && this.state.userDetails.PK ? this.state.userDetails.PK : creatorID,
			type: 'content',
			allowShare: this.state.allowShare,
			createInBoxOffice: this.state.createInBoxOffice,
			allowComments: this.state.allowComments,
			genderSpecific: this.state.selectedGenderType,
			tagsWithGenderTarget: this.state.tagsWithGenderArr,
			// peopleValues: this.state.selectedPeopleList,
			syncToYousaytv: this.state.syncToWordpress,
			contentMetaInfo: {
				jobDetails: contentType == 'Job' ? await this.getJobData() : {},
			},
			scheduledDate: this.getScheduledDate(),
			scheduledTime: this.getScheduledTime(),
			// activeTillDate: Math.trunc(this.state.publishedEndDate.getTime() / 1000),

			contentStatus: 'draft',
			contentVersion: 2,
			// selectedAutoExpireDate: this.state.selectedAutoExpireDate.value,
			// selectedAutoDeleteDate: this.state.selectedAutoDeleteDate.value,
			contentLanguages: [this.state.contentSelectedLangVal],

			targetAreas: this.state.contentSelectedLangVal == 'En' ? ['RestOfIndia', 'TG&AP'] : ['TG&AP'],
			targetAreaV2: targetAreaV2,
		}
		if (contentType == 'Job' && this.state.companyDetails.isNewCompany) {
			const companyInput = {
				companyName: this.state.companyDetails.companyName,
				companyBio: this.state.companyDetails.companyBio,
				companyAddress: this.state.companyDetails.companyAddress,
				companyEmail: this.state.companyDetails.companyEmail,
				phoneNumber: this.state.companyDetails.phoneNumber,
				companyLogo: this.state.companyDetails.companyLogo,
				companyWebsite: this.state.companyDetails.companyWebsite,
				displayMobileNumberInJobPost: this.state.companyDetails.displayMobileNumberInJobPost,
				GST: this.state.companyDetails.selectedGST
			}
			// console.log(companyInput, "===================companyInput")
			const createCompany = await RegisterCompany(companyInput)
			// console.log(createCompany, "=====================createCompanyResponse")
		}

		if (this.contentImage) {
			input.contentMetaInfo['contentImage'] = this.contentImage.substring(
				this.contentImage.indexOf('public')
			)
		}

		if (this.contentImage && editContent && !this.props.duplicateContent) {
			input.contentMetaInfo['contentImages'] = [
				this.contentImage.substring(this.contentImage.indexOf('public')),
			]
		}

		if (!this.props.duplicateContent && editContent) {
			input['PK'] = contentDetails.PK
			input['SK'] = contentDetails.SK
			if (contentDetails.sendPushNotification != this.state.sendPushNotification) {
				input['sendPushNotification'] = this.state.sendPushNotification
			}
			input['originalCreator'] = contentDetails.originalCreator
		} else {
			input['creatorName'] = createdAs
			input['createdAs'] = createdAs
			input['creatorUUID'] = creatorID
			input['originalCreator'] =
				this.state.userDetails && this.state.userDetails.PK ? this.state.userDetails.PK : creatorID

			input['contentID'] = this.props.duplicateContent ?
				this.state.contentID.includes('cont#')
					? this.state.contentID.split('cont#')[1]
					: this.state.contentID : this.state.contentID
			input['sendPushNotification'] = this.state.sendPushNotification
		}
		input['pnPriority'] = this.state.selectedPnPriority

		input[`pnTitle_${contentSelectedLangVal}`] = this.state.pnTitle
			? this.state.pnTitle.substring(0, 45)
			: ''
		if (this.state.sendPushNotification) {
			input['sendPNWithImage'] = this.state.sendPNWithImage ? this.state.sendPNWithImage : false
			if (this.state.sendPNWithImage) {
				input[`pnDescription_${contentSelectedLangVal}`] = this.state.pnDescription
			} else {
				input[`bigTextTitle_${contentSelectedLangVal}`] = this.state.bigTextTitle
			}
		}

		input[`scheduledTime_${contentSelectedLangVal}`] = this.getScheduledTime()
		input[`scheduledDate_${contentSelectedLangVal}`] = this.getScheduledDate()

		// this.state.tagsArr.map((item, index) => {
		//     input['creatorVideoHashTag' + (index + 1)] = this.appendhashToTag(item)
		// })
		// this.state.tagsWithTypeArr.map((item, index) => {
		//     input['creatorVideoHashTag' + (index + 1) + 'AndType'] = this.appendhashToTag(item)
		// })
		// if (this.state.newTagsArr.length > 0) {
		//     let language = this.state.contentSelectedLangVal
		//     if (language == 'En') {
		//         language = 'English'
		//     } else {
		//         language = 'Telugu'
		//     }
		//     const parameters = {
		//         UUID: creatorID,
		//         userHashTags: this.state.newTagsArr,
		//         tagsLanguage: language,
		//         // wordPressTagIDs: this.state.WPTagIds,
		//     }
		// console.log(parameters, 'parameters')
		//     const createTagResponse = await CreateUserHashtag(parameters)
		// console.log(createTagResponse, 'CreateUserHashtag response')
		// }

		// if (this.state.selectedCategory != '') {
		//     const contentCategories = this.state.selectedCategory.split('->')
		//     contentCategories.map((item, index) => {
		//         input['contentCategory' + (index + 1)] = item
		//     })
		// }

		if (this.state.stickyPost) {
			input['isInAppMessage'] = true
			input['stickyPost'] = this.state.stickyPost
			if (
				editContent &&
				contentDetails.stickyInProgressDateTime != undefined &&
				contentDetails.stickyInProgressDateTime != null &&
				contentDetails.stickyInProgressDateTime
			) {
				const stickyPublishedDateTime = contentDetails.stickyInProgressDateTime
				const PresentDateTimeStamp = Math.round(new Date().getTime() / 1000)
				const stickyPushEndDateTime =
					parseInt(stickyPublishedDateTime) + parseInt(this.state.pushRankUpTo) * 60
				if (PresentDateTimeStamp - stickyPushEndDateTime > 0) {
					input['positionFromTop'] = this.state.positionFromTop
				} else {
					input['positionFromTop'] = this.state.pushRankTo
				}
			} else {
				input['positionFromTop'] =
					this.contentStatus != undefined &&
						this.contentStatus != null &&
						this.contentStatus == 'm#published' &&
						this.isPreviouslyStickyPost != undefined &&
						this.isPreviouslyStickyPost != null &&
						this.isPreviouslyStickyPost
						? parseInt(this.state.positionFromTop)
						: parseInt(this.state.pushRankTo)
			}

			input['tempPositionFromTop'] = parseInt(this.state.positionFromTop)
			input['showSticky'] = this.state.showSticky
			if (this.state.showSticky == 'stickyNoOfTimes') {
				input['stickyTargetImpressions'] = this.state.stickyTargetImpressions
			}
			const stickyEndDateTimeStamp = new Date(this.state.stickyEndDateTime).getTime()
			input['stickyEndDateTime'] = Math.floor(stickyEndDateTimeStamp / 1000)
			input['pushRankUpTo'] = parseInt(this.state.pushRankUpTo)
			input['pushRankTo'] = parseInt(this.state.pushRankTo)
			input['isPushRankActive'] = true
		} else {
			input['stickyPost'] = false
			input['isPushRankActive'] = false
			input['isInAppMessage'] = false
			input['isPushRankActive'] = false
		}

		return input
	}
	handleCreateContent = async () => {
		this.setState({ enableCreateContent: false })
		const inputObj = await this.contentInputData(this.state.selectedContentType)
		let input = this.stripTypenames(inputObj)

		let wordPressInfo = this.state.wordPressInfo
		input['syncToYousaytv'] = false
		if (

			this.state.syncToWordpress &&
			!this.state.disableSyncToWordPress
		) {
			input['syncToYousaytv'] = true
		}

		wordPressInfo['wordPressPermaLink'] = this.state.permalink
		let targetAreaCategories = []
		this.state.selectedTargetAreas.map((item, index) => {
			if (item.wordPressCategoryIDs) {
				item.wordPressCategoryIDs.map((catid, catidindex) => {
					targetAreaCategories.push(catid)
				})
			} else {
				targetAreaCategories.push(item.wordPressCategoryID)
			}
		})
		// this.state.WPCatIds.map((item, index) => {
		//     wordPressInfo['wordPressContentCategory' + (index + 1) + 'ID'] = item
		// })
		// let categoryIds = this.state.WPCatIds
		// if (this.state.addNewsToCategory && this.state.newsCategoryId) {
		//     categoryIds.push(this.state.newsCategoryId)
		// }
		// if (this.state.addTargetAreasToWP) {
		//     wordPressInfo['wordPressCategoryIDs'] = categoryIds.concat(targetAreaCategories)

		// }
		// else {
		//     wordPressInfo['wordPressCategoryIDs'] = categoryIds

		// }
		input['wordPressInfo'] = wordPressInfo
		input['addedTargetAreaCategories'] = this.state.addTargetAreasToWP
		// input['addedNewsCategories'] = this.state.addNewsToCategory
		input['targetAreaCategoriesArr'] = targetAreaCategories
		// input['newsCategoriesArr'] = this.state.newsCategoryId

		console.log(input, 'input===========')

		if (this.props.editContent && !this.props.isNewLang) {
			console.log(input, 'here is the input1111111')
			const response = await UpdateContent(input)
			console.log(response, 'response111111===========')
			if (response.statusCode == 'A186') {
				toast.success('Job Updated Successfully', this.toastStyle)
				setTimeout(() => {
					window.location.reload()
				}, 2000)
			} else {
				toast.error('Failed To Update Content', this.toastStyle)
			}
		} else if (this.props.editContent && this.props.isNewLang) {
			console.log(input, 'here is the input')
			const response = await UpdateContent(input)
			console.log(response, 'response122222===========')
			if (response.statusCode == 'A186') {
				toast.success('Job Created Successfully', this.toastStyle)
				setTimeout(() => {
					window.location.reload()
				}, 2000)
			} else {
				toast.error('Failed To Create Job', this.toastStyle)
			}
		} else {
			console.log(input, 'here is the input in createcontent')
			const response = await CreateContentService(input)
			console.log(response, 'response===========')
			if (response.statusCode == 'A184') {
				toast.success('Job Created Successfully', this.toastStyle)
				setTimeout(() => {
					window.location.reload()
				}, 2000)
			} else {
				toast.error('Failed To Create Job', this.toastStyle)
			}
		}
	}
	checkValidationsForChangeContent = (childType) => {

		return true

	}
	changeContentLanguage = async (currentLanguage, language) => {


		const { isGeneralOptionsEdited, selectedContentType } = this.state
		if (currentLanguage != language) {
			if (isGeneralOptionsEdited || this.checkValidationsForChangeContent(selectedContentType)) {
				this.setState({
					modalVisible: true,
					changeToLanguage: language,
					syncToWordpress: language == 'En' ? false : true,
					contentSelectedLangVal: language,
				})
			} else {
				this.setState({ contentSelectedLangVal: language })
			}
		}
	}
	stripTypenames = (value) => {
		if (Array.isArray(value)) {
			return value.map(this.stripTypenames)
		} else if (value !== null && typeof value === 'object') {
			const newObject = {}
			for (const property in value) {
				if (property !== '__typename') {
					newObject[property] = this.stripTypenames(value[property])
				}
			}
			return newObject
		} else {
			return value
		}
	}
	handleCreateAs = (val) => {
		this.setState({ createAs: val })
	}
	handleSelectContributor = (val) => {
		this.setState({ selectedContributor: val })
	}
	handleSelectContentPlanner = (val) => {
		this.setState({ selectedContentPlanner: val })

	}
	handleSendNotification = (e) => {
		this.setState({ sendPushNotification: e.target.checked })
	}
	handlePnPriority = (priority) => {
		this.setState({ selectedPnPriority: priority })
	}
	togglePNWithBigText = () => {
		this.setState({ sendPNWithBigText: !this.state.sendPNWithBigText })
	}
	handleChangeSendPNWith = () => {
		this.setState({ sendPNWithImage: !this.state.sendPNWithImage })
	}
	handlebigTextTitle = (e) => {
		this.setState({ bigTextTitle: e.target.value })
	}
	handlePNTitle = (e) => {
		const pnTitle = e.target.value.substring(0, 45)
		this.setState({ pnTitle: pnTitle })
	}
	handlePNDescription = (e) => {
		const pnDescription = e.target.value.substring(0, 240)
		this.setState({ pnDescription: e.target.value })
	}
	setStartDate = (date) => {
		this.setState({
			scheduledDate: date,
		})
	}
	setEndDate = (date) => {
		this.setState({
			publishedEndDate: date,
		})

	}
	handleTargetAreas = (val) => {
		this.setState({ selectedTargetAreas: val })
	}
	handleAllowShare = (e) => {
		this.setState({ allowShare: e.target.checked })
	}
	handleCreateInBoxOffice = (e) => {
		this.setState({ createInBoxOffice: e.target.checked })
	}
	handleChangeStickyPost = (e) => {
		this.setState(
			{
				stickyPost: e.target.checked,
				isInAppMessage: e.target.checked,
				createInBoxOffice: e.target.checked ? false : true,
			}
		)
	}
	handleAllowComments = (e) => {
		this.setState({ allowComments: e.target.checked })
	}
	handleChangeStickyPositionFromTop = (positionFromTop) => {
		this.setState({
			positionFromTop,
		})
	}
	handleChangeShowStickyOption = (showSticky) => {
		this.setState({
			showSticky,
		})
	}
	handleChangeStickyNoOfTimes = (stickyTargetImpressions) => {
		this.setState({
			stickyTargetImpressions,
		})
	}
	handleChangeStickyEndDateTime = (stickyEndDateTime) => {
		this.setState({
			stickyEndDateTime,
		})
	}
	handleChangePushRankUpTo = (pushRankUpTo) => {
		this.setState({
			pushRankUpTo,
		})
	}
	handleChangePushRankTo = (pushRankTo) => {
		this.setState({
			pushRankTo,
		})
	}

	hasPositionFromTopError = () => {
		return !this.state.positionFromTop
	}

	hasPushRankToError = () => {
		return !this.state.pushRankTo
	}

	hasPushRankUpToError = () => {
		return !this.state.pushRankUpTo
	}

	hasStickyNumberOfTimesError = () => {
		return !this.state.stickyTargetImpressions
	}
	resetDataAndChangeType = () => {
		this.resetGeneralOption()
		this.job = {}
		this.setState({
			modalVisible: !this.state.modalVisible,
			// enableCreateContent: false,
			contentSelectedLangVal: this.state.changeToLanguage,
		})
	}
	resetGeneralOption = () => {
		this.setState({
			contentLang: 'English',
			allowShare: true,
			createInBoxOffice: true,
			allowComments: true,
			sendPNWithImage: true,
			// scheduleTime: moment(new Date()).unix(),
			showDatePicker: false,
			showTimePicker: false,
			modalVisible: false,
			isGeneralOptionsEdited: false,
			generalOptionsExpanded: false,
			pnTitle: '',
			pnDescription: '',
			bigTextTitle: '',
		})
	}
	render() {
		const {

			selectedContentType,
			selectedContributor,
			modalVisible,
			contentModalVisible,
			contentLanguageOptions,
			contentSelectedLangVal,
			companyDetails
		} = this.state
		console.log(this.state.job, 'job============== in render')
		// console.log(this.job, 'job============== in global')
		const selectedType = this.props.editContent ? this.props.contentDetails.contentType : selectedContentType
		return (
			<div class=' row col-md-12'>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>

				{this.state.creationStatus == 'Success' ? (
					<Alert variant='success'>
						<p>Job Created Successfully</p>
					</Alert>
				) : null}
				{this.state.creationStatus == 'Failed' ? (
					<Alert variant='danger'>
						<p>Failed To Create Job</p>
					</Alert>
				) : null}

				<div
					class='col-md-7'
					style={{
						borderStyle: 'solid',
					}}
				>

					<Modal show={modalVisible} onHide={() => this.handleModal()}>
						<Modal.Body>All The Changes Will Be Discarded</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.handleModal()}>Cancel</Button>
							<Button onClick={() => this.resetDataAndChangeType()}>Ok</Button>
						</Modal.Footer>
					</Modal>

					{!this.props.editContent ? (
						<div>
							<div>
								<label for='text'>Choose Content Language</label>
							</div>
							<div className='row'>
								{contentLanguageOptions.map((item, index) => (
									<div className='col-md-3' key={index}>
										<input
											value={contentSelectedLangVal}
											type='radio'
											checked={this.state.contentSelectedLangVal == item.value}
											onChange={() => {
												this.changeContentLanguage(this.state.contentSelectedLangVal, item.value)
											}}
										></input>
										<text for={item.label}>{item.label}</text>
									</div>
								))}
							</div>
						</div>
					) : (
						<div>
							<div>
								<label for='text'>Select Content Language</label>
							</div>
							<div className='row'>
								<text for={this.props.contentSelectedLangVal}>
									{this.props.contentSelectedLangVal}
								</text>
							</div>
						</div>
					)}
					<div class='row col-md-9'>
						<CreateAs
							data={this.state}
							handleCreateAs={this.handleCreateAs}
							handleSelectContributor={this.handleSelectContributor}
							handleSelectContentPlanner={this.handleSelectContentPlanner}
						/>
					</div>
					<div class='row col-md-12'>
						<JobGeneralOptions
							editContent={this.props.editContent}
							data={this.state}
							handlePnPriority={this.handlePnPriority}
							handleSendNotification={this.handleSendNotification}
							// handleGenderTarget={this.handleGenderTarget}
							handleAllowShare={this.handleAllowShare}
							// handleAllowDownloads={this.handleAllowDownloads}
							// handleCreateInBoxOffice={this.handleCreateInBoxOffice}
							handleAllowComments={this.handleAllowComments}
							setStartDate={this.setStartDate}
							setEndDate={this.setEndDate}
							// setPollClosingDate={this.setPollClosingDate}
							togglePNWithBigText={this.togglePNWithBigText}
							handleChangeSendPNWith={this.handleChangeSendPNWith}
							handlebigTextTitle={this.handlebigTextTitle}
							handlePNTitle={this.handlePNTitle}
							handlePNDescription={this.handlePNDescription}
							handleTargetAreas={this.handleTargetAreas}
							handleChangeStickyPost={this.handleChangeStickyPost}
							handleChangeStickyPositionFromTop={this.handleChangeStickyPositionFromTop}
							handleChangeShowStickyOption={this.handleChangeShowStickyOption}
							handleChangeStickyNoOfTimes={this.handleChangeStickyNoOfTimes}
							handleChangeStickyEndDateTime={this.handleChangeStickyEndDateTime}
							contentStatus={this.contentStatus}
							isPreviouslyStickyPost={this.isPreviouslyStickyPost}
							handleChangePushRankUpTo={this.handleChangePushRankUpTo}
							handleChangePushRankTo={this.handleChangePushRankTo}
							hasPositionFromTopError={this.hasPositionFromTopError}
							hasPushRankToError={this.hasPushRankToError}
							hasPushRankUpToError={this.hasPushRankUpToError}
							hasStickyNumberOfTimesError={this.hasStickyNumberOfTimesError}
						/>
					</div>
					{/* {!this.state.stickyPost ? (
                        <div class='row col-md-9'>
                            <InAppMessage
                                ref={this.InAppMessageChild}
                                updateInAppMessageDetails={this.updateInAppMessageDetails}
                                inAppMessageDetails={this.state.inAppMessageDetails}
                                scheduleDate={this.state.scheduledDate}
                                contentStatus={this.contentStatus}
                                isPreviouslyCampaign={this.isPreviouslyCampaign}
                                handleChangeInAppMessageSwitch={this.handleChangeInAppMessageSwitch}
                                key={this.state.isInAppMessage}
                                isInAppMessage={this.state.isInAppMessage}
                            />
                        </div>
                    ) : null} */}
					{this.renderSubContent(selectedType)}
					{this.renderContentMandatoryValidations()}
					{!this.checkDisabled(false) ? (
						<div class='row'>
							{this.props.editContent ? (
								<div class='col-md-4'>
									<Button onClick={() => this.handleCreateContent()} variant='primary'>
										Update Job
									</Button>
								</div>
							) : (
								<div class='col-md-4'>
									<Button onClick={() => this.handleCreateContent()} variant='primary'>
										Create Job
									</Button>
								</div>
							)}
							{/* <div class='col-md-4'>
                                <Button onClick={() => this.preview()} variant='primary'>
                                    Preview
                                </Button>
                            </div> */}
						</div>
					) : (
						<div class='row'>
							{this.props.editContent ? (
								<div class='col-md-4'>
									<Button disabled variant='secondary'>
										Update Job
									</Button>
								</div>
							) : (
								<div class='col-md-4'>
									<Button disabled variant='secondary'>
										Create Job
									</Button>
								</div>
							)}
							<div class='col-md-4'>
								{/* <Button disabled variant='secondary'>
                                    Preview
                                </Button> */}
							</div>
						</div>
					)}
				</div>
				<div class='col-md-1'></div>
				{/* <div class='col-md-4'>
                    <div style={{ height: heightPercentageToDP('100%') }}>
                        <div
                            style={{
                                height: heightPercentageToDP('101%'),
                                width: widthPercentageToDP('100%'),
                                borderStyle: 'solid',
                                position: 'relative',
                            }}
                        >
                            {this.state.previewData ? (
                                <Preview
                                    data={this.state.previewData}
                                    createAs={this.state.createAs}
                                    selectedContributor={selectedContributor}
                                    contentSelectedLangVal={contentSelectedLangVal}
                                />
                            ) : (
                                <p style={{ textAlign: 'center', marginTop: heightPercentageToDP('45%') }}>
                                    Preview here
                                </p>
                            )}
                        </div>
                    </div>
                </div> */}
			</div>
		)
	}
}
export default withRouter(Job)